import { Directive, Injector, Optional, SkipSelf } from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import { TableComponent } from '../table.component';

const DEFAULT_CLS = '';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-table-row',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmTableRow]',
  providers: [
    provideAsWidgetRef(TableRowDirective)
  ],
  standalone: true,
  exportAs: 'wmTableRow'
})
export class TableRowDirective extends StylableComponent {
  static initializeProps = register('wm-table-row');
  config: any;
  columnwidth: any;
  closeothers: any;
  content: any;
  expandicon: any;
  expandtitle: any;
  collapseicon: any;
  collapsetitle: any;
  override height: any;
  position: any;
  show: boolean;
  disabled: boolean;
  class: string;
  widgettype: string;
  private binddisplayName: any;
  private bindshow: any;
  private binddisabled: any;
  private bindtitle: string | null;
  private bindcontent: string | null;

  constructor(inj: Injector, @Optional() viewParent: Parent, @Optional() @SkipSelf() public table: TableComponent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  populateConfig() {
    this.config = {
      closeothers: this.nativeElement.getAttribute('closeothers'),
      content: this.getBoundVal('content'),
      columnwidth: this.nativeElement.getAttribute('columnwidth'),
      expandicon: this.nativeElement.getAttribute('expandicon'),
      collapseicon: this.nativeElement.getAttribute('collapseicon'),
      height: this.nativeElement.getAttribute('height'),
      position: this.nativeElement.getAttribute('position'),
      show: this.getBoundVal('show'),
      disabled: this.getBoundVal('disabled'),
      class: this.nativeElement.getAttribute('class'),
      widgetType: this.nativeElement.getAttribute('widget-type'),
      displayName: this.getBoundVal('display-name'),
      expandtitle: this.getBoundVal('expandtitle'),
      collapsetitle: this.getBoundVal('collapsetitle'),
      onBeforerowexpand: this.nativeElement.getAttribute('beforerowexpand.event'),
      onRowexpand: this.nativeElement.getAttribute('rowexpand.event'),
      onBeforerowcollapse: this.nativeElement.getAttribute('beforerowcollapse.event'),
      onRowcollapse: this.nativeElement.getAttribute('rowcollapse.event')
    };
  }

  getBoundVal(prop: string) {
    let propName = prop + '.bind';
    let val = this.nativeElement.getAttribute(propName);
    if (val && val !== 'null') {
      return ('bind:' + val);
    }
    return this.nativeElement.getAttribute(prop) || undefined;
  }

  override ngOnInit() {
    super.ngOnInit();
    this.populateConfig();
    this.table.registerRow(this.config, this);
  }

  override onPropertyChange(key: string, nv: any) {
    if (key === 'content' && this.config) {
      this.config.content = this.content;
    }
  }
}

